interface Suggestion {
  label: string;
  value: string;
}

const getAddressSuggestions = async (
  query: string,
  max: number = 5,
): Promise<Suggestion[]> => {
  if (!query) return [];

  const defaultExtent = [-88.7056, 42.153, -88.1977, 42.4953];

  const params = new URLSearchParams({
    f: "json",
    text: query,
    category: "Address",
    searchExtent: defaultExtent.join(","),
    maxSuggestions: max.toString(),
  });

  const geocodingUrl = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?${params}`;

  const blacklistedAddresses = [] as string[];

  try {
    const responses = await fetch(geocodingUrl);

    const data = (await responses.json()) as {
      suggestions?: { text: string; magicKey: string }[];
    };

    const suggestions = data.suggestions ?? [];

    const addressSuggestions = suggestions.map(({ text, magicKey }) => ({
      label: text,
      value: magicKey,
    }));

    return addressSuggestions.filter((row) => {
      return !blacklistedAddresses.includes(row.label);
    });
  } catch (error) {
    console.error("Error fetching address suggestions:", error);
    return [];
  }
};

export { getAddressSuggestions };
